export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            联系投稿
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            欢迎提供爆料线索、商务合作与内容投稿
          </p>
        </div>
        <div className="max-w-xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-mail-send-line text-lg"></i>
              </div>
              <div>
                <h3 className="font-heading text-base text-foreground-900 mb-1">
                  投稿合作通道
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  如果您有独家爆料线索、娱乐圈一手资讯或希望与51吃瓜视频进行内容合作与商务洽谈，欢迎通过以下方式联系我们。我们珍视每一位内容贡献者，期待与您共创优质的吃瓜内容生态。
                </p>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-mail-line"></i>
                </div>
                <span>投稿邮箱：contact@51chigua.com</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-wechat-line"></i>
                </div>
                <span>商务微信：51chigua_official</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-foreground-600">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                  <i className="ri-time-line"></i>
                </div>
                <span>工作时间：每日 9:00 - 21:00（节假日不休）</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}